import { Timestamp } from 'firebase/firestore';
import { MonthYear } from '../utils/MonthYear/monthYear';
import { DashboardNotification } from './notificationType';

export interface IInventoryProduct {
  product: string;
  value: number;
  date: MonthYear;
  quantity: number;
  reportingTime?: Timestamp;
}

export interface IMaterialInventory {
  materialName: string;
  formulaId: string;
  futureOrders: { date: MonthYear; value: number }[];
  financialPositions: { date: MonthYear; value: number }[];
  inventoryProducts: IInventoryProduct[];
  exposureRisk: number;
  netExposure?: number;
  color?: string;
  accountId?: string;
}

export interface IInventory {
  materialInventory: IMaterialInventory[];
  accountId: string;
  notifications: DashboardNotification[];
  statusFiles: InventoryStatusFile[];
}

export interface InventoryStatusFile {
  fileId: string;
  fileUrl: string;
  fileName: string;
  status: 'CREATED' | 'HANDLED' | 'INVALID';
  created: Timestamp;
  updated: Timestamp;
}

export type exposureStatusType =
  | 'danger-appreciation'
  | 'danger-depreciation'
  | 'alert-appreciation'
  | 'alert-depreciation'
  | 'flat';

export type trendDirectionType = 'appreciation' | 'depreciation' | 'flat';

export const materialColors: string[] = [
  '#0B8CD4',
  '#5467B2',
  '#7A67B6',
  '#BB62B0',
  '#6574C5',
  '#0083B1',
  '#1591C6',
  '#2866A8',
  '#6799E0',
  '#88BDEC',
  '#88AFD1',
];

export const DEFAULT_COLOR = '#EAEAEB'; // '#5467B2';
export const GENERAL = 'General';
export const CNY_ID = 'CNY='; // this is the China Yuan to USD conversion symbol (its data exist in materials list)

export const materialIdMap = {
  '15': { name: 'Steel HRC', color: '#5467B2' },
  '16': { name: 'Steel Rebar', color: '#7A67B6' },
  '17': { name: 'Structural', color: '#BB62B0' },
};

export type monthToVal = { [key: number]: number };
